import { Tooltip, Typography } from "@material-ui/core";
import * as React from "react";
import HelpIcon from '@material-ui/icons/Help';

interface Props {
    text: string;
}

export const HoverHelp = (props: Props) => {
    return (
        <Tooltip title={<Typography variant="body1">{props.text}</Typography>}>
            <HelpIcon fontSize={"small"} />
        </Tooltip>
    );
}